import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { ToolbarStoreContext } from '../contexts/StoreContext'
import { ToolbarStore } from '../store/interface'

export const useToolbarStore: UseStore<ToolbarStore> = selector => {
  return useContextStore(ToolbarStoreContext, selector)
}
